import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    transition:
      transform 0.15s ease,
      color 0.15s ease;

    svg {
      height: 25px;
      width: 25px;
    }

    &:hover {
      transform: translateY(-1px) scale(1.05);
    }

    &:active {
      transform: translateY(0) scale(0.97);
    }
  }

  /* Contribution chips inside the tables */
  span[data-tooltip-id='standard-tooltip'] {
    background: ${({ theme }) => theme.colors.surfaceElevated} !important;
    color: ${({ theme }) => theme.colors.textPrimary} !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
  }
`

export const Th = styled.th`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  padding: 10px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Td = styled.td`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.tableRowAlt};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tableRowHover};
  }
`

export const TableContainer = styled.div`
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 40px;
  width: 100%;
`

export const AddButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  transition:
    transform 0.15s ease,
    color 0.15s ease;

  &:hover {
    transform: translateY(-1px) scale(1.05);
  }

  &:active {
    transform: translateY(0) scale(0.97);
  }

  svg {
    height: 30px;
    width: 30px;
  }
`

export const Chip = styled.span`
  display: inline-block;
  background: ${({ theme }) => theme.colors.surfaceElevated};
  color: ${({ theme }) => theme.colors.textPrimary};
  border-radius: 12px;
  padding: 4px 10px;
  margin-right: 6px;
  margin-bottom: 4px;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition:
    transform 0.12s ease,
    box-shadow 0.18s ease,
    background 0.2s ease,
    color 0.2s ease;

  ${({ $clickable }) =>
    $clickable &&
    `
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(0,0,0,0.12);
    }
    &:active {
      transform: translateY(0);
      box-shadow: 0 3px 8px rgba(0,0,0,0.12);
    }
  `}
`
